import styled from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";

export const TestimonialContainer = styled.div`
  width: 100%;
  height: 565px;
  background: #fff;
  padding: 100px 1px 113px 70px;
  display: flex;
  justify-content: center;
  /* border: 2px solid red; */
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 768px;
    height: 923px;
    display: flex;
    padding: 60px 0px 113px 70px;
    flex-direction: column;
    align-items: flex-start;
    /* justify-content: center; */
    gap: 61.908px;
    background: var(--General-White, #fff);
  }

  @media screen and (max-width: 430px) {
    width: 375px;
    height: 954px;

    display: flex;
    padding: 62px 0px 70px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 75px;
    background: var(--General-White, #fff);
  }
  @media screen and (max-width: 375px) {
    width: 375px;
    height: 854px;

    display: flex;
    padding: 62px 0px 70px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 75px;
    background: var(--General-White, #fff);
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    height: 854px;

    display: flex;
    padding: 62px 0px 70px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 75px;
    background: var(--General-White, #fff);
  }
`;
